import { QsrAutomationsMode } from './qsr_automations_mode.js';

export function name(mode: QsrAutomationsMode): string {
  switch (mode) {
    case QsrAutomationsMode.Sending:
      return 'Sending';
    case QsrAutomationsMode.PosWebhooks:
      return 'POS Webhooks';
  }
}
